module.exports = __webpack_public_path__ + "img/ring_of_regen.55520394.png";